import { mockData } from "./Mock";
import { Product, ProductListResponse } from "../../models/Product";

const mockProducts: Product[] = [
    {
        id: "P001",
        name: "测试商品1",
        sellerId: "S001",
        sellerNickname: "测试卖家1",
        categoryLevel1: "数码",
        categoryLevel2: "手机",
        status: 1,
        draftStatus: 0,
        recentExposures: 1000,
        recentClicks: 100,
        orderCount: 50,
        completedCount: 45,
        createTime: "2024-03-15 10:00:00",
        onlineTime: "2024-03-15 12:00:00",
        forceOfflineRecords: []
    },
    {
        id: "P002",
        name: "测试商品2",
        sellerId: "S002",
        sellerNickname: "测试卖家2",
        categoryLevel1: "服装",
        categoryLevel2: "男装",
        status: 0,
        draftStatus: 1,
        recentExposures: 500,
        recentClicks: 50,
        orderCount: 20,
        completedCount: 18,
        createTime: "2024-03-14 10:00:00",
        onlineTime: "",
        forceOfflineRecords: [
            {
                offlineTime: "2024-03-13 15:00:00",
                reason: "违规商品",
                operator: "admin"
            }
        ]
    }
];

const productListResponse: ProductListResponse = {
    products: mockProducts
};

mockData.set("PRODUCT_LIST", productListResponse); 